module.exports = __webpack_public_path__ + "static/media/prpg2.189cde8f.png";